module.exports = __webpack_public_path__ + "img/20190902152524482.42bea725.jpg";